import { Component, OnInit, Output, EventEmitter, Input, Inject } from '@angular/core';
import * as _ from 'lodash';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { MAT_DIALOG_DATA } from '@angular/material';
import { ModalService } from 'src/app/shared/services/modal.service';

@Component({
  selector: 'app-edit-customer-entitlements',
  templateUrl: './edit-customer-entitlements.component.html',
  styleUrls: ['./edit-customer-entitlements.component.scss']
})
export class EditCustomerEntitlementsComponent implements OnInit {
  constructor(
    private customerService: CustomerService,
    private modal: ModalService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  public table: { header: Array<any>, headerBoolean: Array<Boolean>, body: Array<any> } = { header: [], headerBoolean: [], body: [] };
  public loading: boolean = false;
  private lockedEntitlements = ['HC_CUSTOMER_TRACKTRACE']; // these locks and exclusives should be done dynamically not within code
  private exclusiveLocks = ['HC_CUSTOMER_PURCHASE_ORDERS', 'HC_CUSTOMER_ORDER_ENTRY', 'HC_CUSTOMER_RATE_INQUIRY', 'HC_CUSTOMER_ANALYTICS', 'HC_CUSTOMER_TPS_RATE_REQUEST', 'HC_CUSTOMER_OM_LTL_RATE_INQ_ORDER_ENTRY']

  ngOnInit() {
    this.loading = true;
    this._buildEntitlements(this.data.activeRoleDefaultEntitlements, this.data.activeRoleCustomEntitlements);
    this._buildTable(this.data.activeRoleDefaultEntitlements);
    this.loading = false;
  };

  public close() {
    this.modal.close();
  };

  public checkDisabled(entitlement, index) {
    if (
      !this.table.headerBoolean[index] ||
      this.lockedEntitlements.find(lock => { return lock === entitlement }) ||
      (this.exclusiveLocks.find(lock => { return lock === entitlement }) && this.table.headerBoolean[index])
    ) {
      return true;
    } else {
      return false;
    }
  }

  public enableChildren(index) {
    let bool = !this.table.headerBoolean[index];
    this.table.body[index].forEach(element => {
      if (!this.lockedEntitlements.find(lock => { return lock === element.code})) {
        element.enabled = bool;
      }
    });

    let rateArray = ['TPS Rate Inquiry','Rate Inquiry','OM Orders'];
    if(bool && rateArray.indexOf(this.table.header[index]) >= 0) {
      let selectedValue = this.table.header[index];
      rateArray = rateArray.filter((value) => value != selectedValue);
      rateArray.forEach((item)=>{
        const i = this.table.header.findIndex((heading) => heading === item);
        this.table.headerBoolean[i] = !bool;
        this.table.body[i].forEach(element => {
          element.enabled = !bool;
        })
      })
    }
  }

  public saveEntitlements() {
    let entitlements = _.flattenDeep(this.table.body);
    entitlements.forEach(element => {
      delete element.name;
    });
    this.customerService.updateOrganizationEntitlements(this.data.roleId, entitlements);
    this.modal.close({ code: this.data.activeRole, entitlements: entitlements });
  }

  private _buildTable(entitlements) {
    entitlements.forEach(entitlement => {
      if ( entitlement.label && !this.table.header.find(element =>  element === entitlement.label)) {
        this.table.header.push(entitlement.label)
        this.table.body.push([]);
        this.table.headerBoolean.push(false);
      };
    });
    this.table.header.sort();
    entitlements.forEach(entitlement => {
      this.table.header.forEach((element, index) => {
        if (element === entitlement.label) {
          this.table.body[index].push({ code: entitlement.code, name: entitlement.name, enabled: _.get(entitlement, 'status', false) })
          if (this.table.body[index][this.table.body[index].length-1].enabled) {
            this.table.headerBoolean[index] = true;
          }
        }
      });
    });
  };

  private _buildEntitlements(defaultEntitlements, customEntitlements) {
    defaultEntitlements.forEach((defaultEntitlement, i) => {
      customEntitlements.forEach(customEntitlement => {
        if (customEntitlement.code === defaultEntitlement.code) {
          this.data.activeRoleDefaultEntitlements[i].status = customEntitlement.enabled;
        }
      });
    });
  }

}
